import { Route, Routes, useLocation, useSearchParams } from "react-router-dom";

import { OTPVerificationContainer } from "../pages/Onboarding/containers";
import { PAGES_PATH } from "./params";
import PrivateRoutesContainer from "./PrivateRoutesContainer";
import PublicRoutesContainer from "./PublicRoutesContainer";
import React from "react";
import { constructUrlPath } from "../utils/url-path";
import { useUserStatusStore } from "../hooks/redux-hooks/user-status/user-status.store";
import { useUserStore } from "../hooks/redux-hooks/user-store/user.store";

export const Routing: React.FC = () => {
  const { tokenNew } = useUserStore();
  const { emailSignIn, phoneSignIn } = useUserStatusStore();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isQR = searchParams.get("isqr");
  const utmSource = searchParams.get("utm_source");
  const utmContent = searchParams.get("utm_content");
  const utmMedium = searchParams.get("utm_medium");
  const utmCampaign = searchParams.get("utm_campaign");
  const autologinEmail = searchParams.get("autologin");
  const redirectionParam = searchParams.get("path");

  const fetchUserStatus = () => {
    if ((!emailSignIn && !phoneSignIn) || !tokenNew) {
      return false;
    }

    return true;
  };

  const QRValidation = isQR !== "false" && isQR !== null;


  if (utmSource || utmContent || utmMedium || utmCampaign || QRValidation) {
    localStorage.setItem("isWebUserApiCalled", "true");
    localStorage.setItem("wellness-utm", JSON.stringify({
      utmSource, utmContent, utmMedium, utmCampaign,
      arrivedAt: new Date().toISOString(), isWellnessPageRedirect: redirectionParam ? false : true,
    }));
  } else if (autologinEmail) {
    localStorage.removeItem("isWebUserApiCalled");
  }

  if (redirectionParam) {
    const constructedRedirectionUrl = constructUrlPath(Object.fromEntries(searchParams.entries()));

    localStorage.setItem("redirectionPath", constructedRedirectionUrl);
  }

  // Preserve deep links across login so a logged-out user who lands on the
  // login screen is sent back to the intended flow afterwards. Covers the
  // complete-purchase SMS entry (`/complete-purchase`), the in-hospital handoff
  // (`/complete-purchase/<prequalificationId>`), and the prequalification
  // eligibility deep link (`/prequalification`, optionally with `?id=`).
  const isCompletePurchaseDeepLink =
    location.pathname === PAGES_PATH.COMPLETE_PURCHASE ||
    location.pathname.startsWith(`${PAGES_PATH.COMPLETE_PURCHASE}/`);
  const isPrequalificationDeepLink = location.pathname === PAGES_PATH.PREQUALIFICATION;

  if (!fetchUserStatus() && (isCompletePurchaseDeepLink || isPrequalificationDeepLink)) {
    localStorage.setItem("redirectionPath", `${location.pathname}${location.search}`);
  }

  return (
    <>
      <Routes>
        {
          fetchUserStatus() ? (
            <Route path="*" element={<PrivateRoutesContainer />} />
          ) : (
            <Route path="*" element={<PublicRoutesContainer />} />
          )
        }
        <Route
          path={PAGES_PATH.OTP_VERIFICATION}
          element={<OTPVerificationContainer />}
        />
      </Routes>
    </>
  );
};
